import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from '../screens/auth/Login';
import AdminsRoutes from './AdminsRoutes'; // Import your admin routes
import UserRoutes from './UsersRoutes'; // Import your user routes
import { isAuthenticated, getPortal, getHomePath } from '../utils/auth';

/**
 * Which shell a session gets, and nothing finer.
 *
 * This used to branch on the role name, which no longer means anything fixed
 * now that admins create their own roles. A role carries a `portal` instead,
 * and what is visible *inside* a shell is decided per screen by the
 * permission guards in AdminsRoutes and UsersRoutes.
 *
 * Only the matching tree is mounted, so a /user session typing /admin/users
 * falls through to the catch-all and is sent to their own home screen.
 */
function AppRoute() {
  const signedIn = isAuthenticated();
  const portal = getPortal();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {signedIn ? (
          <>
            {portal === 'admin' && <Route path="/admin/*" element={<AdminsRoutes />} />}
            {portal === 'user' && <Route path="/user/*" element={<UserRoutes />} />}
            {/* Anything outside this session's shell goes to its home screen.
                Not to "/": the login page clears storage on mount, and storage
                is shared by every tab, so a stray link opened in a new tab
                used to sign the user out everywhere. */}
            <Route path="*" element={<Navigate to={getHomePath()} replace />} />
          </>
        ) : (
          <Route path="*" element={<LoginPage />} />
        )}
      </Routes>
    </Router>
  );
}

export default AppRoute;
